import { createRoot } from "react-dom/client";
import "./cui/sass/cui.theme.scss";
import ApplicationRoot from "./ApplicationRoot";
import reportWebVitals from "./reportWebVitals";
const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error('Unable to find the element with id="root".');
}

createRoot(rootElement).render(<ApplicationRoot />);
 
reportWebVitals();